<template>
    <div class="flex flex-col min-h-screen">
        <slot name="header"/>
        <div class="flex-1" :class="background">
            <slot/>
        </div>
        <slot name="footer"/>
    </div>
</template>

<script>
    export default {
        props: {
            background: {
                type: String,
                default: 'bg-transparent'
            }
        }
    }
</script>


